import {BuyableFeatureGate, BuyableId, CommonBuyables} from './types';

// Buyables that are provisioned and sold with monthly caps, rather than term caps
// These buyables (various flavors of MTUs) also should be provisioned in buckets
// and displayed with monthly totals (not totals per term) in the frontend
export const MONTHLY_BUCKETED_BUYABLES: string[] = [CommonBuyables.MTUS];

// Buyables that should display quantity per bucket (rather than per month or per term)
export const BUCKET_QUANTITY_BUYABLES: string[] = [CommonBuyables.SESSION_REPLAY];

// All buyables that use buckets (union of monthly and per-bucket buyables)
export const ALL_BUCKETED_BUYABLES: string[] = [...MONTHLY_BUCKETED_BUYABLES, ...BUCKET_QUANTITY_BUYABLES];

// These are the template IDs for the free plan, which can be automatically included in the
// the upcoming agreements if there is no renewal agreement. These should be excluded from
// being displayed in the upcoming renewal.
export const FREE_PLAN_TEMPLATE_IDS = [3, 700, 21234];

export const CORE_METERED_BUYABLES = [BuyableId.EVENTS, BuyableId.MTUS];

export const SUPPORT_FEATURE_GATES = [
  BuyableFeatureGate.SILVER_SERVICE_PLAN,
  BuyableFeatureGate.GOLD_SERVICE_PLAN,
  BuyableFeatureGate.PLATINUM_SERVICE_PLAN,
  BuyableFeatureGate.MCDONALDS_CUSTOM_SERVICE_PLAN,
  BuyableFeatureGate.STANDARD_ONBOARDING_PACKAGE,
  BuyableFeatureGate.STRATEGIC_ONBOARDING_PACKAGE,
];

// TODO: GOOT to prevent affecting overage rate. Long-term fix is in backlog
export const SERVICE_CHARGE_BUYABLES = [
  BuyableId.STANDARD_ONBOARDING_PACKAGE,
  BuyableId.STRATEGIC_ONBOARDING_PACKAGE,
  BuyableId.INDIA_DATACENTER_MIGRATION_SERVICES,
];

export const ENTERPRISE_FEATURE_GATES = [
  BuyableFeatureGate.ENTERPRISE,
  BuyableFeatureGate.ENTERPRISE_PLAN_WITH_PROFILES,
  BuyableFeatureGate.MTU_ENTERPRISE,
];

export const ENABLE_ITB_DISCLAIMERS = true;

// Buyables that can be marked as "grandfathered" to carry over existing SKU values across renewals/plan changes
export const GRANDFATHERABLE_BUYABLE_IDS: BuyableId[] = [BuyableId.CUSTOM_EVENTS_RETENTION_PERIOD];

export const CURRENT_DEFAULT_RETENTION_PERIOD = 365 * 2; // 2 years in days
export const DEFAULT_MAX_DATA_RETENTION_DAYS = 365 * 10; // fallback when no limits are set

export const GROUP_ANALYTICS_BUYABLE_IDS: BuyableId[] = [
  BuyableId.GROUP_ANALYTICS_1,
  BuyableId.GROUP_ANALYTICS_3,
  BuyableId.GROUP_ANALYTICS_6,
];
